function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 24,
  height: 24
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.7,14H14.7893l.42651-4H18.7a.5.5,0,0,0,0-1H15.3225l.47418-4.44678a.50015.50015,0,0,0-.44433-.55029.51531.51531,0,0,0-.54981.44385L14.317,9H10.3225l.47418-4.44678a.50015.50015,0,0,0-.44433-.55029.51229.51229,0,0,0-.54981.44385L9.317,9H5.29961a.5.5,0,0,0,0,1H9.21032L8.7838,14H5.29961a.5.5,0,0,0,0,1h3.3775l-.47418,4.44678a.50016.50016,0,0,0,.44434.55029A.48241.48241,0,0,0,8.701,20a.49985.49985,0,0,0,.49609-.44678L9.68261,15h3.9945l-.47418,4.44678a.50016.50016,0,0,0,.44434.55029A.48241.48241,0,0,0,13.701,20a.49985.49985,0,0,0,.49609-.44678L14.68261,15H18.7a.5.5,0,1,0,0-1ZM9.7893,14l.42651-4h3.99451l-.42652,4Z"
});

function SvgTags(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.1d6bbcc0.svg";
export { ForwardRef as ReactComponent };